/* eslint-disable @typescript-eslint/ban-types */
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
} from '@material-ui/core'
import React from 'react'
import clsx from 'clsx'
import { PrimaryRadio } from '../../../../MaterialUi/Radio'
import { useStyle } from './Style'
import { FlatsyButtonsProps } from './Type'

export const FlatsyButtonsField = ({
  value,
  onChange,
  label,
  options,
  name,
  error,
  onBlur,
}: FlatsyButtonsProps): React.ReactElement => {
  const classes = useStyle()

  return (
    <FormControl
      onBlur={onBlur}
      component="fieldset"
      error={!!error?.message}
      name={name}
      key={name}
      className={classes.formGroup}
    >
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <RadioGroup
        aria-label={name}
        name={name}
        value={value}
        onChange={onChange}
        className={classes.group}
      >
        {options.map((option) => (
          <FormControlLabel
            value={option.value}
            key={`radioButton-${name}-${option.value}`}
            control={<PrimaryRadio key={`radioControl-${option.value}`} />}
            label={option.label}
            className={clsx(classes.item, value === option.value ? classes.itemActive : undefined)}
            name={`${name}-${option.value}`}
            data-cy={`radio-${name}-${option.value}`}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  )
}

export default FlatsyButtonsField
